import { unescape } from 'lodash';
import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class DraftApi<Draft> extends BaseAPI {
  // constructor() {}

  public getAllDrafts: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/draft/`)).data.output;
  };

  public getCurrentFilteredDrafts: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/draft/current-filtered`)).data.output;
  }

  public getDraftsByTitleId: (titleId: number) => Promise<any> = async (titleId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/draft/GetByTitleId/${titleId}`)).data.output;
  };

  public createDraft: (draft: Draft) => Promise<any> = async (draft: Draft) => {
    return (await BaseAPI.axios.post(`${baseUrl}/draft/`, draft)).data.output;
  };

  public deleteDraftById: (id: number) => Promise<any> = async (id: number) => {
    return (await BaseAPI.axios.delete(`${baseUrl}/draft/deleteById/${id}`)).data.output;
  };

  public getPreview: (id: number) => Promise<any> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/draft/${id}/preview`)).data;
  }

  public getCleanedPreview: (id: number) => Promise<any> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/draft/${id}/cleanPreview`)).data;
  }

  public getHistorical: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/draft/historical`)).data.output;
  }

  public getDraftEditStatus: (id: number) => Promise<any> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/draft/${id}/getDraftEditStatus`)).data;
  }
}

export const draftAPI = new DraftApi();
